module.exports = __webpack_public_path__ + "img/not-done.3f93b5cb.png";